<div class="content m-0 p-0 ">
  <div class="d-flex justify-content-between mb-1 ps-2 bg-primary align-items-end pb-3">

    <div class="ps-4 pt-2 d-flex align-items-baseline"  [routerLink]="serial.includes('EVVC') ? ['diagnosis'] : ['/dashboard/device', serial]">
      <h1 class="text-white m-0 me-2"
       >
        {{objectDevice?.info?.name}}
      </h1>
      <h5 class="text-light me-3"
        data-cy="deviceComponent-serial">
        ({{ serial }})
      </h5>
      <h5 class="badge bg-white text-dark fw-bold" >
        v - {{objectDevice?.info?.firmware_version_name}}
      </h5>
    </div>
    <div style="height: auto; max-height: 100px;">
      <div class="float-start d-flex" >
        <a class="nav-link" (click)="goToLink(serial)" *ngIf="userRole=='admin'">
          <i class="fas fa-dice-d20 text-white"></i>
        </a>
        <a class="nav-link text-white" [routerLink]="['/dashboard/device', serial]" data-cy="deviceDashboard-button"
          [ngClass]="{'btn btn-light text-dark': (this._router.url.includes('device')&&!this._router.url.includes('settings')&&!this._router.url.includes('modules')&&!this._router.url.includes('diagnosis')&&!this._router.url.includes('spl')&&!this._router.url.includes('subscriptions')&&!this._router.url.includes('historical')&&!this._router.url.includes('analytics') )}">
          <i class="fas fa-eye"></i>
        </a>
        <a class="nav-link text-white" [routerLink]="['diagnosis']" data-cy="deviceDiagnosis-button" *ngIf="serial.includes('EVVC')"
          [ngClass]="{'btn btn-light text-dark': (this._router.url.includes('diagnosis')&&!this._router.url.includes('settings')&&!this._router.url.includes('modules'))}">
          <i class="fas fa-stethoscope"></i>
        </a>

        <a class="nav-link text-white" [routerLink]="['analytics']" data-cy="deviceAnalytics-button" *ngIf="deviceSubtype=='astro_lum'"
          [ngClass]="{'btn btn-light text-dark': (this._router.url.includes('analytics')&&!this._router.url.includes('settings')&&!this._router.url.includes('modules'))}">
          <i class="fa-solid fa-chart-line"></i>
        </a>

        <a class="nav-link text-white" [routerLink]="['historical']" data-cy="deviceDiagnosis-button" *ngIf="!serial.includes('EVVC')"
          [ngClass]="{'btn btn-light text-dark': (this._router.url.includes('historical')&&!this._router.url.includes('settings')&&!this._router.url.includes('modules')  )}">
          <!-- <i class="fa-solid fa-chart-line"></i> -->
          <i class="fa-solid fa-clipboard-list fs-3"></i>
        </a>

        <a class="nav-link text-white" [routerLink]="['spl']" *ngIf="splMode == 1 "
          [ngClass]="{'btn btn-light text-dark': (this._router.url.includes('spl')&&!this._router.url.includes('settings')&&!this._router.url.includes('modules'))}">
          <i class="fas fa-sitemap"></i>
        </a>
        <ul class="p-0 m-0">
          <li class="position-relative" style="list-style-type: none;">
            <div class="float-start d-flex mx-3">
              <a class="nav-link position-relative text-white" data-cy="deviceSettings-button"
                [ngClass]="{'btn btn-light text-dark': this._router.url.includes('settings')}" routerLink="settings">
                <i class="align-middle cog-device-set fas fa-cog"></i>
              </a>
              <a class="nav-link position-relative text-white"
                [ngClass]="{'btn btn-light text-dark': this._router.url.includes('subscriptions')}"
                routerLink="subscriptions" *ngIf="userRole=='admin' && deviceSubtype=='exo'">
                <i class="align-middle fas fa-cart-plus"></i>
              </a>
              <a class="nav-link position-relative text-white" data-cy="deviceModules-button"
                [ngClass]="{'btn btn-light text-dark': this._router.url.includes('modules')}" routerLink="modules"
                *ngIf="userRole=='admin'">
                <i class="align-middle fas fa-cogs"></i>
              </a>
            </div>
            <!-- <a class="nav-link dropdown-toggle position-relative" id="userDropdown" data-toggle="dropdown">
                  <i class="align-middle cog-device-set fas fa-cog text-white ms-3"></i>
              </a> -->
            <div class="dropdown-menu dropdown-menu-right dropdown-menu-settings-device" style="top: 50px !important;">
              <a class="dropdown-item" routerLink="settings/connectivity"><i
                  class="align-middle me-1 fas fa-fw fa-broadcast-tower"></i> {{"connectivity" | translate}}</a>
              <a class="dropdown-item" routerLink="settings/password" href="#"><i
                  class="align-middle me-1 fas fa-fw fa-key"></i> {{"password" | translate}}</a>
              <a class="dropdown-item" routerLink="settings/wifi" href="#"><i
                  class="align-middle me-1 fas fa-fw fa-wifi"></i>
                {{"wifi" | translate}}</a>
              <a class="dropdown-item" routerLink="settings/power" href="#"><i
                  class="align-middle me-1 fas fa-fw fa-bolt"></i> {{"power" | translate}}</a>
              <a class="dropdown-item" routerLink="settings" routerLink="settings"><i
                  class="align-middle me-1 fas fa-fw fa-clock"></i> {{"datetime" | translate}}</a>
              <a class="dropdown-item" href="#"><i class="align-middle me-1 fas fa-fw fa-calendar-alt"></i>
                {{"hourScheduler" |
                translate}}</a>
              <a class="dropdown-item" href="#"><i class="align-middle me-1 fas fa-fw fa-hand-pointer"></i>
                {{"touchRfid" |
                translate}}</a>
              <a class="dropdown-item" routerLink="settings/ocpp"><i class="align-middle me-1 fas fa-fw fa-cogs"></i>
                {{"ocpp"
                | translate}}</a>
              <a class="dropdown-item" href="#"><i class="align-middle me-1 fas fa-fw fa-cloud-download-alt"></i>
                {{"fw_update" | translate}}</a>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
  <div class="m-0">
    <router-outlet></router-outlet>

  </div>
